import { AvField, AvForm } from "availity-reactstrap-validation";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    FormGroup,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    UncontrolledAlert,
    Collapse
} from "reactstrap";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DATABASE_VEHICULE_FORM, DATABASE_VEHICULE_PAGE } from "../../routes/routeConstants";
import { vehiculeActions } from "./vehiculeSlice";
import CurrencyInput from "react-currency-input-field";
import { dataActions } from "../dataSlice";

const initForm = {
    id: 0,
    categVeh: '',
    reform: 'TECHNIQUE',
    marque: '',
    type: '',
    genre: '',
    modele: '',
    carburant: '',
    numChassis: '',
    nbrCylindres: 0,
    puissFiscale: 0,
    immatriculation: "",
    immanterieur: "",
    firstMec: null,
    mecMaroc: null,
    dateSinistre: null,
    ageMonths: 0,
    ageYears: 0,
    etatVehicule: null,
    usage: "",
    proprietere: "",
    prestataire: null,
    compteur: 0,
    fraisimm: 0,
    ville: null,
    assurance: null,
    entretReg: null,
    valMarche: 0,
    epave: 0,
    devis: 0,
    prixAchat: 0,
    coefCommercial:0,
    documents:[],
};

const VehiculeForm = () => {
    const { t } = useTranslation('translation');
    const [formState, setForm] = useState(initForm);
    const { isFetching } = useSelector(state => state.vehicule);
    const { categVH, reform, villes, assurances, entrestruc } = useSelector(state => state.data);
    const [cg, setCg] = useState(null);
    const [cg2, setCg2] = useState(null);
    const [facture, setFacture] = useState(null);
    const [error, setError] = useState(null);
    const [recordError, setRecordError] = useState({ open: false, message: null });

    const [openSections, setOpenSections] = useState({
        document: true,
        chassis: false,
        sinistre: false,
        admin: false,
        valeurs: false,
    });

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        if (categVH.length == 0) {
            dispatch(dataActions.loadData())
        }
    }, [])

    useEffect(() => {
        if (id) {
            let payload = {
                id,
                onSuccess: (data) => {
                    setForm({ ...data });
                }
            }
            dispatch(vehiculeActions.find(payload));
        }
    }, [id, dispatch]);

    const toggleSection = (name) => {
        setOpenSections(prev => ({ ...prev, [name]: !prev[name] }));
    };

    const breadcrumbItems = [
        { title: t('database'), link: "#" },
        { title: t('vehicule'), link: DATABASE_VEHICULE_PAGE },
        { title: id > 0 ? t('editvehicule') : t('newvehicule'), link: "#" }
    ];

    const formik = useFormik({
        initialValues: { ...formState },
        enableReinitialize: true,
        onSubmit: (values) => {

            if (!values.categVeh || values.categVeh.length === 0) {
                setError("Chossissez un catégorie");
                return;
            }

            setError(null);

            const isUpdate = values.id > 0;

            const payload = {
                data: values,
                onSuccess: (vehicle) => {
                    const vId = isUpdate ? values.id : vehicle?.body?.id;

                    // Upload CG if provided
                    if (cg) {
                        const formData = new FormData();
                        formData.append("file", cg);
                        formData.append("vId", vId);
                        formData.append("documentType", "CG1");

                        dispatch(vehiculeActions.uploadDocument({
                            formData,
                            onSuccess: () => console.log("CG uploaded"),
                            onError: (e) => console.warn("CG upload error", e)
                        }));
                    }

                    if (cg2) {
                        const formData = new FormData();
                        formData.append("file", cg2);
                        formData.append("vId", vId);
                        formData.append("documentType", "CG2");

                        dispatch(vehiculeActions.uploadDocument({
                            formData,
                            onSuccess: () => console.log("CG2 uploaded"),
                            onError: (e) => console.warn("CG2 upload error", e)
                        }));
                    }

                    // Upload Facture if provided
                    if (facture) {
                        const formData = new FormData();
                        formData.append("file", facture);
                        formData.append("vId", vId);
                        formData.append("documentType", "FACT");

                        dispatch(vehiculeActions.uploadDocument({
                            formData,
                            onSuccess: () => console.log("Facture uploaded"),
                            onError: (e) => console.warn("Facture upload error", e)
                        }));
                    }

                    navigate(DATABASE_VEHICULE_PAGE);
                }
            };

            // Create or update
            if (isUpdate) {
                dispatch(vehiculeActions.update(payload));
            } else {
                dispatch(vehiculeActions.create(payload));
            }
        }
    });


    const handleChangeAssurance = ({ target }) => {
        formik.setFieldValue("assurance", { id: target.value });
    }

    const handleChangeVille = ({ target }) => {
        formik.setFieldValue("ville", { id: target.value });
    }

    useEffect(() => {
        const { firstMec, dateSinistre } = formik.values;

        if (firstMec) {
            const age = calculateAge(firstMec, dateSinistre);
            formik.setFieldValue("ageYears", age.years, false);
            formik.setFieldValue("ageMonths", age.months, false);
        }
    }, [formik.values.firstMec, formik.values.dateSinistre]);

    const extractFacture = (event) => {
        const files = event.target.files;
        if (!files || !files[0]) return;
        setFacture(files[0]);
    };

    const extractCG1 = (event) => {
        const files = event.target.files;
        if (!files || !files[0]) return;
        setCg(files[0]);
    };

    const extractCG2 = (event) => {
        const files = event.target.files;
        if (!files || !files[0]) return;
        setCg2(files[0]);

    };

    const calculateAge = (firstMec, dateSinistre) => {
        if (!firstMec) return { years: 0, months: 0 };

        const start = new Date(firstMec);
        const end = dateSinistre ? new Date(dateSinistre) : new Date();

        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
            return { years: 0, months: 0 };
        }

        let years = end.getFullYear() - start.getFullYear();
        let months = end.getMonth() - start.getMonth();

        if (months < 0) {
            years--;
            months += 12;
        }

        // If day of month not reached, adjust month difference
        if (end.getDate() < start.getDate()) {
            months--;
            if (months < 0) {
                years--;
                months += 12;
            }
        }

        return { years: Math.max(years, 0), months: Math.max(months, 0) };
    };


    const handleChangeCategVH = ({ target }) => {
        formik.setFieldValue('categVeh', categVH.find(d => d.code === target.value)?.code || '');
    };

    return (
        <React.Fragment>
            {isFetching ? (
                <div id="preloader">
                    <div id="status">
                        <div className="spinner">
                            <i className="ri-loader-line spin-icon"></i>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="page-content">
                    <Container fluid={true}>
                        <Breadcrumbs title={t('newvehicule')} breadcrumbItems={breadcrumbItems} />
                        <Card>
                            <CardBody>
                                <AvForm className="needs-validation" onValidSubmit={formik.handleSubmit}>
                                    {/* Documents upload */}
                                    <Card className="mt-4">
                                        <CardHeader
                                            onClick={() => toggleSection('document')}
                                            className="d-flex justify-content-between align-items-center cursor-pointer"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <div>
                                                <i className="ri-car-line me-2"></i>
                                                {t('vehiculef.section_document')}
                                            </div>
                                            <i className={openSections.document ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
                                        </CardHeader>
                                        <Collapse isOpen={openSections.document}>
                                            <CardBody>
                                                <Row>
                                                    <Col sm="4">
                                                        <Label className="form-label" htmlFor="cgFile">{t('vehiculef.cg')}</Label>
                                                        <div className="input-group">
                                                            <input
                                                                id="cgFile"
                                                                accept="application/pdf, image/jpeg, image/png, image/gif, image/bmp"
                                                                type="file"
                                                                className="form-control"
                                                                onChange={extractCG1}
                                                            />
                                                        </div>
                                                        <div className="input-group mt-3">
                                                            {cg && <small>{cg.name}</small>}
                                                            {cg && (
                                                                <Button
                                                                    className="mx-2"
                                                                    size="sm"
                                                                    type="button"
                                                                    color="danger"
                                                                    onClick={() => { setCg(null) }}
                                                                >
                                                                    <i className="ri-delete-bin-2-line"></i>
                                                                </Button>
                                                            )}
                                                            {cg && (
                                                                <Button
                                                                    size="sm"
                                                                    type="button"
                                                                    color="info"
                                                                    onClick={() => {
                                                                        const url = window.URL.createObjectURL(cg);
                                                                        if (cg?.type === "application/pdf") {
                                                                            window.open(url, '_blank')?.focus();
                                                                        } else {
                                                                            const link = document.createElement("a");
                                                                            link.href = url;
                                                                            link.setAttribute("download", `${cg.name}`);
                                                                            document.body.appendChild(link);
                                                                            link.click();
                                                                        }
                                                                    }}
                                                                >
                                                                    <i className="ri-file-download-line"></i>
                                                                </Button>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col sm="4">
                                                        <Label className="form-label" htmlFor="cgFile">{t('vehiculef.cg2')}</Label>
                                                        <div className="input-group">
                                                            <input
                                                                id="cgFile"
                                                                accept="application/pdf, image/jpeg, image/png, image/gif, image/bmp"
                                                                type="file"
                                                                className="form-control"
                                                                onChange={extractCG2}
                                                            />
                                                        </div>
                                                        <div className="input-group mt-3">
                                                            {cg2 && <small>{cg2.name}</small>}
                                                            {cg2 && (
                                                                <Button
                                                                    className="mx-2"
                                                                    size="sm"
                                                                    type="button"
                                                                    color="danger"
                                                                    onClick={() => { setCg2(null) }}
                                                                >
                                                                    <i className="ri-delete-bin-2-line"></i>
                                                                </Button>
                                                            )}
                                                            {cg2 && (
                                                                <Button
                                                                    size="sm"
                                                                    type="button"
                                                                    color="info"
                                                                    onClick={() => {
                                                                        const url = window.URL.createObjectURL(cg2);
                                                                        if (cg2?.type === "application/pdf") {
                                                                            window.open(url, '_blank')?.focus();
                                                                        } else {
                                                                            const link = document.createElement("a");
                                                                            link.href = url;
                                                                            link.setAttribute("download", `${cg2.name}`);
                                                                            document.body.appendChild(link);
                                                                            link.click();
                                                                        }
                                                                    }}
                                                                >
                                                                    <i className="ri-file-download-line"></i>
                                                                </Button>
                                                            )}
                                                        </div>
                                                    </Col>

                                                    <Col sm="4">
                                                        <Label className="form-label" htmlFor="factureFile">{t('vehiculef.facture')}</Label>
                                                        <div className="input-group">
                                                            <input
                                                                id="factureFile"
                                                                accept="application/pdf, image/jpeg, image/png, image/gif, image/bmp"
                                                                type="file"
                                                                className="form-control"
                                                                onChange={extractFacture}
                                                            />
                                                        </div>
                                                        <div className="input-group mt-3">
                                                            {facture && <small>{facture.name}</small>}
                                                            {facture && (
                                                                <Button
                                                                    className="mx-2"
                                                                    size="sm"
                                                                    type="button"
                                                                    color="danger"
                                                                    onClick={() => { setFacture(null) }}
                                                                >
                                                                    <i className="ri-delete-bin-2-line"></i>
                                                                </Button>
                                                            )}
                                                            {facture && (
                                                                <Button
                                                                    size="sm"
                                                                    type="button"
                                                                    color="info"
                                                                    onClick={() => {
                                                                        const url = window.URL.createObjectURL(facture);
                                                                        if (facture?.type === "application/pdf") {
                                                                            window.open(url, '_blank')?.focus();
                                                                        } else {
                                                                            const link = document.createElement("a");
                                                                            link.href = url;
                                                                            link.setAttribute("download", `${facture.name}`);
                                                                            document.body.appendChild(link);
                                                                            link.click();
                                                                        }
                                                                    }}
                                                                >
                                                                    <i className="ri-file-download-line"></i>
                                                                </Button>
                                                            )}
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    {formState.documents.map((doc, index) => (
                                                        <Col md="6" lg="4" key={index} className="mb-3">
                                                            <Card className="shadow-sm border">
                                                                <CardBody>

                                                                    {/* HEADER */}
                                                                    <div className="d-flex align-items-center mb-2">
                                                                        {doc.fileType === "application/pdf" ? (
                                                                            <i className="ri-file-pdf-line text-danger" style={{ fontSize: 30 }}></i>
                                                                        ) : (
                                                                            <i className="ri-image-line text-info" style={{ fontSize: 30 }}></i>
                                                                        )}
                                                                        <div className="ms-2">
                                                                            <h6 className="mb-0">{doc.filenameUser}</h6>
                                                                            <small className="text-muted">{doc.createdDate}</small>
                                                                        </div>
                                                                    </div>

                                                                    {/* BUTTONS */}
                                                                    <div className="d-flex justify-content-between">

                                                                        {/* Open */}
                                                                        <Button
                                                                            size="sm"
                                                                            color="info"
                                                                            onClick={() => window.open(doc.path, "_blank")}
                                                                        >
                                                                            <i className="ri-eye-line"></i> {t('actions.view') || 'Consulter'}
                                                                        </Button>

                                                                        
                                                                    </div>

                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </CardBody>
                                        </Collapse>
                                    </Card>
                                    {/* Basic vehicle fields */}


                                    {/* ===================== SECTION CHASSIS & IDENTIFICATION ===================== */}
                                    <Card className="mt-4">
                                        <CardHeader
                                            onClick={() => toggleSection('chassis')}
                                            className="d-flex justify-content-between align-items-center cursor-pointer"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <div>
                                                <i className="ri-car-line me-2"></i>
                                                {t('vehiculef.section_chassis')}
                                            </div>
                                            <i className={openSections.chassis ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
                                        </CardHeader>
                                        <Collapse isOpen={openSections.chassis}>
                                            <CardBody>
                                                <Row className='mt-3'>
                                                    <Col md="3">
                                                        <Label htmlFor="categorie" className="form-label">{t('parametrage.categorieV')}</Label>
                                                        <select
                                                            required
                                                            className="form-control"
                                                            id='categorie'
                                                            {...formik.getFieldProps('categVeh')}
                                                            onChange={handleChangeCategVH}
                                                        >
                                                            <option value="">Sélectionner...</option>
                                                            {categVH.map((option, index) =>
                                                                <option key={index} value={option.code}>
                                                                    {option.description}
                                                                </option>
                                                            )}
                                                        </select>
                                                        {error && <p style={{ color: "red" }}>{error}</p>}
                                                    </Col>

                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="marque">{t('vehiculef.marque')}</Label>
                                                        <AvField
                                                            {...formik.getFieldProps('marque')}
                                                            placeholder={t('vehiculef.marque')}
                                                            type="text"
                                                            errorMessage={t('message.required')}
                                                            className="form-control"
                                                            id="marque"
                                                        />
                                                    </Col>

                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="type">{t('vehiculef.type')}</Label>
                                                        <AvField
                                                            {...formik.getFieldProps('type')}
                                                            placeholder={t('vehiculef.type')}
                                                            type="text"
                                                            errorMessage={t('message.required')}
                                                            className="form-control"
                                                            id="type"
                                                        />
                                                    </Col>

                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="genre">{t('vehiculef.genre')}</Label>
                                                        <AvField
                                                            {...formik.getFieldProps('genre')}
                                                            placeholder={t('vehiculef.genre')}
                                                            type="text"
                                                            className="form-control"
                                                            id="genre"
                                                        />
                                                    </Col>

                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="modele">{t('vehiculef.modele')}</Label>
                                                        <AvField
                                                            {...formik.getFieldProps('modele')}
                                                            placeholder={t('vehiculef.modele')}
                                                            type="text"
                                                            className="form-control"
                                                            id="modele"
                                                        />
                                                    </Col>

                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="carburant">{t('vehiculef.carburant')}</Label>
                                                        <AvField
                                                            {...formik.getFieldProps('carburant')}
                                                            placeholder={t('vehiculef.carburant')}
                                                            errorMessage={t('message.required')}
                                                            type="text"
                                                            className="form-control"
                                                            id="carburant"
                                                        />
                                                    </Col>

                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="numChassis">{t('vehiculef.numChassis')}</Label>
                                                        <AvField
                                                            {...formik.getFieldProps('numChassis')}
                                                            placeholder={t('vehiculef.numChassis')}
                                                            errorMessage={t('message.required')}
                                                            type="text"
                                                            className="form-control"
                                                            id="numChassis"
                                                        />
                                                    </Col>

                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="nbrCylindres">{t('vehiculef.nbrCylindres')}</Label>
                                                        <AvField
                                                            {...formik.getFieldProps('nbrCylindres')}
                                                            placeholder={t('vehiculef.nbrCylindres')}
                                                            errorMessage={t('message.required')}
                                                            type="number"
                                                            className="form-control"
                                                            id="nbrCylindres"
                                                        />
                                                    </Col>

                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="puissFiscale">{t('vehiculef.puissFiscale')}</Label>
                                                        <AvField
                                                            {...formik.getFieldProps('puissFiscale')}
                                                            placeholder={t('vehiculef.puissFiscale')}
                                                            errorMessage={t('message.required')}
                                                            type="number"
                                                            className="form-control"
                                                            id="puissFiscale"
                                                        />
                                                    </Col>
                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="immatriculation">{t('vehiculef.immatriculation')}</Label>
                                                        <AvField
                                                            {...formik.getFieldProps('immatriculation')}
                                                            id="immatriculation"
                                                            type="text"
                                                            className="form-control"
                                                        />
                                                    </Col>

                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="immanterieur">{t('vehiculef.immanterieur')}</Label>
                                                        <AvField
                                                            {...formik.getFieldProps('immanterieur')}
                                                            id="immanterieur"
                                                            type="text"
                                                            className="form-control"
                                                        />
                                                    </Col>

                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="firstMec">{t('vehiculef.firstMec')}</Label>
                                                        <AvField
                                                            {...formik.getFieldProps('firstMec')}
                                                            id="firstMec"
                                                            type="date"
                                                            className="form-control"
                                                        />
                                                    </Col>

                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="mecMaroc">{t('vehiculef.mecMaroc')}</Label>
                                                        <AvField
                                                            {...formik.getFieldProps('mecMaroc')}
                                                            id="mecMaroc"
                                                            type="date"
                                                            className="form-control"
                                                        />
                                                    </Col>

                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="ageMonths">{t('vehiculef.ageMonths')}</Label>
                                                        <AvField
                                                            {...formik.getFieldProps('ageMonths')}
                                                            id="ageMonths"
                                                            type="number"
                                                            className="form-control"
                                                            disabled
                                                        />
                                                    </Col>

                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="ageYears">{t('vehiculef.ageYears')}</Label>
                                                        <AvField
                                                            {...formik.getFieldProps('ageYears')}
                                                            id="ageYears"
                                                            type="number"
                                                            className="form-control"
                                                            disabled
                                                        />
                                                    </Col>

                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="compteur">{t('vehiculef.compteur')} (km)</Label>
                                                        <AvField
                                                            {...formik.getFieldProps('compteur')}
                                                            id="compteur"
                                                            type="number"
                                                            className="form-control"
                                                        />
                                                    </Col>


                                                </Row>
                                            </CardBody>
                                        </Collapse>
                                    </Card>

                                    {/* ===================== SECTION SINISTRE ===================== */}
                                    <Card className="mt-4">
                                        <CardHeader
                                            onClick={() => toggleSection('sinistre')}
                                            className="d-flex justify-content-between align-items-center cursor-pointer"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <div>
                                                <i className="ri-alert-line me-2"></i>
                                                {t('vehiculef.section_sinistre')}
                                            </div>
                                            <i className={openSections.sinistre ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
                                        </CardHeader>
                                        <Collapse isOpen={openSections.sinistre}>
                                            <CardBody>
                                                <Row>
                                                    <Col md="4">
                                                        <Label className="form-label" htmlFor="dateSinistre">{t('vehiculef.dateSinistre')}</Label>
                                                        <AvField
                                                            {...formik.getFieldProps('dateSinistre')}
                                                            id="dateSinistre"
                                                            type="date"
                                                            className="form-control"
                                                        />
                                                    </Col>
                                                    <Col md="4">
                                                        <Label className="form-label" htmlFor="etatVehicule">{t('vehiculef.etatVehicule')}</Label>
                                                        <select
                                                            required
                                                            className="form-control"
                                                            id='etatVehicule'
                                                            {...formik.getFieldProps('etatVehicule')}
                                                            onChange={(e) => formik.setFieldValue('etatVehicule', e.target.value)}
                                                        >
                                                            <option value="">Sélectionner...</option>
                                                            <option value="ETAT_1">Bon</option>
                                                            <option value="ETAT_2">Moyen</option>
                                                        </select>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Collapse>
                                    </Card>

                                    {/* ===================== SECTION ADMINISTRATIF ===================== */}
                                    <Card className="mt-4">
                                        <CardHeader
                                            onClick={() => toggleSection('admin')}
                                            className="d-flex justify-content-between align-items-center cursor-pointer"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <div>
                                                <i className="ri-file-list-line me-2"></i>
                                                {t('vehiculef.section_admin')}
                                            </div>
                                            <i className={openSections.admin ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
                                        </CardHeader>
                                        <Collapse isOpen={openSections.admin}>
                                            <CardBody>
                                                <Row>
                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="usage">{t('vehiculef.usage')}</Label>
                                                        <AvField
                                                            {...formik.getFieldProps('usage')}
                                                            id="usage"
                                                            type="text"
                                                            className="form-control"
                                                        />
                                                    </Col>

                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="proprietere">{t('vehiculef.proprietere')}</Label>
                                                        <AvField
                                                            {...formik.getFieldProps('proprietere')}
                                                            id="proprietere"
                                                            type="text"
                                                            className="form-control"
                                                        />
                                                    </Col>
                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="ville">{t('vehiculef.ville')}</Label>
                                                        <select
                                                            required
                                                            className="form-control"
                                                            id='ville'
                                                            {...formik.getFieldProps('ville')}
                                                            value={formik.values.ville?.id}
                                                            onChange={handleChangeVille}
                                                        >
                                                            <option value="">Sélectionner...</option>
                                                            {villes.map((option, index) =>
                                                                <option key={index} value={option.id}>
                                                                    {option.description}
                                                                </option>
                                                            )}
                                                        </select>
                                                        {error && <p style={{ color: "red" }}>{error}</p>}
                                                    </Col>

                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="assurance">{t('vehiculef.assurance')}</Label>

                                                        <select
                                                            required
                                                            className="form-control"
                                                            id='assurance'
                                                            {...formik.getFieldProps('assurance')}
                                                            value={formik.values.assurance?.id}
                                                            onChange={handleChangeAssurance}
                                                        >
                                                            <option value="">Sélectionner...</option>
                                                            {assurances.map((option, index) =>
                                                                <option key={index} value={option.id}>
                                                                    {option.description}
                                                                </option>
                                                            )}
                                                        </select>
                                                        {error && <p style={{ color: "red" }}>{error}</p>}
                                                    </Col>

                                                    <Col md="4">
                                                        <Label className="form-label" htmlFor="entretReg">{t('vehiculef.entretReg')}</Label>
                                                        <select
                                                            required
                                                            className="form-control"
                                                            id='prestataire'
                                                            {...formik.getFieldProps('prestataire')}
                                                            value={formik.values.prestataire?.id}
                                                            onChange={({ target }) => {
                                                                if (target.value) {
                                                                    formik.setFieldValue('prestataire', { id: target.value });
                                                                    const struc = entrestruc.find(e => e.id == target.value);
                                                                    formik.setFieldValue('entretReg', struc.entretReg);
                                                                }
                                                            }}
                                                        >
                                                            <option value="">Sélectionner...</option>
                                                            {entrestruc.map((option, index) =>
                                                                <option key={index} value={option.id}>
                                                                    {`${option.entretReg} - ${option.prestataire}`}
                                                                </option>
                                                            )}
                                                        </select>
                                                        {error && <p style={{ color: "red" }}>{error}</p>}
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Collapse>
                                    </Card>

                                    {/* ===================== SECTION VALEURS & FINANCE ===================== */}
                                    <Card className="mt-4 mb-4">
                                        <CardHeader
                                            onClick={() => toggleSection('valeurs')}
                                            className="d-flex justify-content-between align-items-center cursor-pointer"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <div>
                                                <i className="ri-money-dollar-circle-line me-2"></i>
                                                {t('vehiculef.section_valeurs')}
                                            </div>
                                            <i className={openSections.valeurs ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
                                        </CardHeader>
                                        <Collapse isOpen={openSections.valeurs}>
                                            <CardBody>
                                                <Row>
                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="prixAchat">{t('vehiculef.prixAchat')}</Label>
                                                        <AvField
                                                            {...formik.getFieldProps('prixAchat')}
                                                            placeholder={t('vehiculef.prixAchat')}
                                                            errorMessage={t('message.required')}
                                                            type="number"
                                                            className="form-control"
                                                            validate={{ required: { value: true } }}
                                                            id="prixAchat"
                                                        />
                                                    </Col>
                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="valMarche">{t('vehiculef.valMarche')}</Label>
                                                        <CurrencyInput
                                                            id="valMarche"
                                                            name="valMarche"
                                                            className="form-control"
                                                            value={formik.values.valMarche}
                                                            decimalsLimit={2}
                                                            onValueChange={(v) => formik.setFieldValue("valMarche", v)}
                                                        />
                                                    </Col>

                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="epave">{t('vehiculef.epave')}</Label>
                                                        <CurrencyInput
                                                            id="epave"
                                                            name="epave"
                                                            className="form-control"
                                                            value={formik.values.epave}
                                                            decimalsLimit={2}
                                                            onValueChange={(v) => formik.setFieldValue("epave", v)}
                                                        />
                                                    </Col>

                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="devis">{t('vehiculef.devis')}</Label>
                                                        <CurrencyInput
                                                            id="devis"
                                                            name="devis"
                                                            className="form-control"
                                                            value={formik.values.devis}
                                                            decimalsLimit={2}
                                                            onValueChange={(v) => formik.setFieldValue("devis", v)}
                                                        />
                                                    </Col>
                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="fraisimm">{t('vehiculef.fraisimm')}</Label>
                                                        <CurrencyInput
                                                            id="fraisimm"
                                                            name="fraisimm"
                                                            className="form-control"
                                                            value={formik.values.fraisimm}
                                                            decimalsLimit={2}
                                                            onValueChange={(v) => formik.setFieldValue("fraisimm", v)}
                                                        />
                                                    </Col>
                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="remise">{t('vehiculef.remise')}</Label>
                                                        <CurrencyInput
                                                            id="remise"
                                                            name="remise"
                                                            className="form-control"
                                                            value={formik.values.remise}
                                                            decimalsLimit={2}
                                                            onValueChange={(v) => formik.setFieldValue("remise", v)}
                                                        />
                                                    </Col>
                                                    <Col md="3">
                                                        <Label className="form-label" htmlFor="remise">{t('vehiculef.coefCommercial')}</Label>
                                                        <CurrencyInput
                                                            id="coefCommercial"
                                                            name="coefCommercial"
                                                            className="form-control"
                                                            value={formik.values.coefCommercial}
                                                            decimalsLimit={2}
                                                            onValueChange={(v) => formik.setFieldValue("coefCommercial", v)}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mt-4">
                                                    <Col md="12">
                                                        {reform?.map((item, index) => (
                                                            <FormGroup check inline key={index}>
                                                                <div className="mb-3 form-check">
                                                                    <AvField
                                                                        type="radio"
                                                                        name="reform"
                                                                        value={item.code}
                                                                        className="form-check-input"
                                                                        id={`reform_${index}`}
                                                                        checked={item.code === formik.values.reform}
                                                                        onChange={() => formik.setFieldValue('reform', item.code)}
                                                                    />
                                                                    <label className="form-check-label" htmlFor={`reform_${index}`}>
                                                                        {t(item.description)}
                                                                    </label>
                                                                </div>
                                                            </FormGroup>
                                                        ))}
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Collapse>
                                    </Card>

                                    <Button color="primary" type="submit">
                                        {t('actions.save')}
                                    </Button>
                                </AvForm>
                            </CardBody>
                        </Card>
                    </Container>
                </div>
            )}

            <Modal
                isOpen={recordError.open}
                toggle={() => setRecordError({ ...recordError, open: false })}
                backdrop="static"
            >
                <ModalHeader toggle={() => setRecordError({ ...recordError, open: false })}>
                    {t('text.errorTitle')}
                </ModalHeader>
                <ModalBody>
                    <p>{recordError.message}</p>
                    <ModalFooter>
                        <Button
                            type="button"
                            color="light"
                            onClick={() => setRecordError({ ...recordError, open: false })}
                        >
                            {t('actions.close')}
                        </Button>
                    </ModalFooter>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

export default VehiculeForm;
